import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, Input, Form, Checkbox } from 'antd';
import { agentActions, getCompanyDetails } from '../../actions'
import {
    setRememberMe, getRememberMe, removeRememberMe
} from '../../utils/auth'
import { loadImg } from '../../utils/index';
import { login } from '../../service/login';
import EventBus from '../../components/eventBus';
import './style.scss'

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            rememberMe: 'rememberMeUnFocus',
            loginError: '',
            isRememberPwd: false
        };
    }
    loginForm = React.createRef();
    loginImgRef = React.createRef();

    componentDidMount() {
        // loadImg('/images/login-img.png').then((img)=> {
        //     this.loginImgRef.current.appendChild(img)
        // })
        const _this = this;
        // 获取公司信息，并存入reducer中，后续有用
        this.props.actions.getCompanyDetails();
        if (getRememberMe()) {
            const preUserName = localStorage['preSaveName'];
            const prePwd = this.getRememberPwd(preUserName)
            if (preUserName && preUserName) {
                this.loginForm.current.setFieldsValue({
                    username: preUserName,
                    password: prePwd
                })
            }
            this.setState({
                isRememberPwd: true
            })
        } else {
            this.setState({
                isRememberPwd: false
            })
        }

        EventBus.addListener('login', function (url) {
            _this.props.history.push(url);
        })
    }
    componentWillUnmount() {
        EventBus.removeListener('login');
    }

    handleSubmit = (values) => {
        let { username, password } = values;
        if (!username.trim() || !password) {
            this.setState({ loginError: '请输入用户名、密码' })
            return;
        }
        this.setState({
            loading: true
        })
        if (this.state.isRememberPwd) {
            setRememberMe();
        } else {
            removeRememberMe();
        }
        login({
                loginName: username,
                password,
                flag: ''
            })
            .then(response => {
                localStorage['preSaveName'] = username.trim();
                localStorage['preSavePwd'] = password;
                this.setState({ loginError: '' });
                this.props.actions.agentLoginFinish(response);
                this.setState({ loading: false });
            })
            .catch(err => {
                this.setState({ loading: false });
            })
    }

    toggleRememberPwd = event => {
        const { checked } = event.target;
        if (checked) {
            setRememberMe();
        } else {
            removeRememberMe();
        }
        this.setState({ isRememberPwd: checked })
    }

    getRememberPwd(username) {
        try {
            let savedUser = JSON.parse(localStorage.localUser);
            if (savedUser && getRememberMe()) {
                const result = savedUser.find(item => Object.keys(item).includes(username));
                if (result) {
                    return result[username];
                }
            }
        }
        catch (err) {
            return '';
        }
    }
    onValuesChange = (values) => {
        if (Object.keys(values).includes('username')) {
            const pwd = this.getRememberPwd(values.username);
            if (pwd) {
                this.loginForm.current && this.loginForm.current.setFieldsValue({
                    password: pwd
                })
            }
        }
    }

    render() {
        const { loading, loginError, isRememberPwd } = this.state;

        return (
            <div className="login-container">
                {/* <div className="login-img"><div className="login-img-bj" ref={this.loginImgRef}></div></div> */}
                <div className="login-box">
                    <h1 className="login-title">一站式保险理赔系统</h1>
                    <Form className="login-form" layout="vertical" onFinish={this.handleSubmit} ref={this.loginForm} onValuesChange={this.onValuesChange}>
                        <div className="login-form-wrap">
                            <h2 className="login-form-t"><span>登录</span></h2>
                            <Form.Item name="username">
                                <Input placeholder="输入用户名" autoCapitalize='off' prefix="账号" />
                            </Form.Item>
                            <Form.Item name="password" style={{ marginBottom: 5 }}>
                                <Input placeholder="输入密码" type="password" prefix="密码" />
                            </Form.Item>
                            <Form.Item>
                                <Checkbox checked={isRememberPwd} onChange={this.toggleRememberPwd} style={{ color: '#AFB8D4'}}>记住密码</Checkbox>
                            </Form.Item>
                            <Form.Item noStyle>
                                <div className="errorMessage">{loginError}</div>
                            </Form.Item>
                            <Form.Item >
                                <Button type="primary" className="login-btn" htmlType="submit" loading={loading}>登录</Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}


let mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({},
            agentActions,
            getCompanyDetails,
        ), dispatch)
    }
};

export default connect(
    null,
    mapDispatchToProps
)(Login)
